import React, { useState, useRef, useEffect, useCallback } from 'react';
import { format } from 'date-fns';
import defaultUserImage from 'assets/images/logo/default-user.jpg';
import pdfLogo from 'assets/images/logo/pdf.png';
import speechBubble from 'assets/images/logo/speech-bubble.gif';
import './patientConversation.css';
import { getPatientConversationList, getProvidermessages,sendMessage,updateACMEReadMessage } from 'apiServices';
import { Modal } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';





const MessageContainer = ({ message, currentUser, selectedUser, openAttachmentDialog, previewImage, isValidDate, messageDate }) => {
  const isOwnMessage = message.sender_id === currentUser.user_id;

  const messageContainerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: isOwnMessage ? 'flex-end' : 'flex-start',
    marginBottom: "15px",
    width: "100%"
  };

  const messageStyle = {
    display: "flex",
    flexDirection: "column",
    backgroundColor: isOwnMessage ? '#007bff' : '#f0f0f0',
    padding: '12px',
    borderRadius: '12px',
    color: isOwnMessage ? 'white' : 'black',
    maxWidth: '70%',
    minWidth: '100px',
    position: 'relative',
    fontSize: '0.8rem',
    cursor: 'pointer',
    fontWeight: 'bold'
  };

  const timeStampStyle = {
    fontSize: '0.75rem',
    marginTop: '5px',
    opacity: '0.8',
    display: 'flex',
    alignItems: 'center',
    gap: '5px'
  };

  const fileCardStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '8px',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '8px',
    cursor: 'pointer'
  };

  return (
    <div style={messageContainerStyle}>
      <div style={messageStyle}>
        {selectedUser?.isenable_chat === 0 && (
          <div style={{ marginBottom: '5px' }}>
            <u><b>{message.message_createdby}</b></u>
          </div>
        )}
        
        {message.message_type_id === 1 && (
          <div style={{ wordBreak: 'break-word' }}>{message.message}</div>
        )}
        
        {message.message_type_id === 2 && (
          <div style={fileCardStyle} onClick={() => openAttachmentDialog(message.message_id, message.chat_id)}>
            <div className="file-icon">
              <img src={pdfLogo} style={{ width: '24px', height: '24px' }} alt="PDF" />
            </div>
            <div>
              <div style={{ fontWeight: 'bold' }}>{message.file_name}</div>
              <div style={{ fontSize: '0.8rem' }} onClick={() => openAttachmentDialog(message)}>Click to view</div>
            </div>
          </div>
        )}
        
        {message.message_type_id === 3 && (
          <img 
            src={message.media_path} 
            alt="Image Preview" 
            style={{ 
              maxWidth: '100%', 
              borderRadius: '8px',
              cursor: 'pointer'
            }}
            onClick={() => previewImage(message.media_path, message.message_id)}
          />
        )}
        
        <div style={timeStampStyle}>
          {isValidDate && format(messageDate, 'p')}
          {isOwnMessage && (
            <i className={`fa fa-${message.isread ? 'eye' : 'eye-slash'}`} 
               style={{ marginLeft: '5px' }} />
          )}
        </div>
      </div>
    </div>
  );
};

const PatientConversation = () => {
  // Redux hooks
  const token = useSelector((state) => state.apiService.token);
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.apiService.login);

  // State
  const [usermsgsLst, setUsermsgsLst] = useState([]);
  const [usermsgsLstRead, setUsermsgsLstRead] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [providermsgs, setProvidermsgs] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [isUserScrolledUp, setIsUserScrolledUp] = useState(false);
  const [ischatEnabled, setIsChatEnabled] = useState(true);
  const [shouldAutoScroll, setShouldAutoScroll] = useState(true);
  const [currentUser, setCurrentUser] = useState();
  const [unreadMessageMap, setUnreadMessageMap] = useState({});
  const [Imageprofile, setImageprofile] = useState(defaultUserImage);

  // Refs
  const messageContainer = useRef(null);
  const scrollPositionBeforeUpdate = useRef(null);
  const scrollThreshold = 100;

  // API params
  const params = {
    token: token,
    user_id: userData.user_id,
    chatId: 0,
    searchKey:''
  };
  const paramsRead = {
    token: token,
    loginUserId: userData.user_id,
    chatId: 0,
    isread:true
  };
  setTimeout(() => {
  //  getmessagesListProvider();
  }, 2000);

  // Effects
  useEffect(() => {
    setCurrentUser(userData);
    getmessagesListProvider();
  }, []); // Initial load only

  useEffect(() => {
    if (selectedUser) {
      selectUser(selectedUser);
    }
  }, [selectedUser]); // Only fetch messages when user is selected

  useEffect(() => {
    if (shouldAutoScroll) {
      scrollToBottom(false);
    } else if (scrollPositionBeforeUpdate.current && messageContainer.current) {
      const container = messageContainer.current;
      container.scrollTop = container.scrollHeight - scrollPositionBeforeUpdate.current;
    }
  });

  useEffect(() => {
    scrollToBottom(true);
  }, []);
  const getmessagesListProviderRead = async () => {
    setUsermsgsLst([]);
    dispatch(getPatientConversationList(params)).then((response) => {
      console.log("getmessagesListProvider response", response);
      const list = response.payload.Table;
      const userList = list.map(user => ({
        chat_id: user.chat_id,
        sender_id: user.sender_id,
        receiver_id: user.receiver_id,
        user_id: user.user_id,
        sender_name: user.sender_name,
        image_path: user.image_path,
        latest_message: user.latest_message,
        
        isread: user.isread
      }));
      setUsermsgsLst(userList);
    });
  }

  const getmessagesListProvider = async () => {
    setUsermsgsLst([]);
    dispatch(getPatientConversationList(params)).then((response) => {
      console.log("getmessagesListProvider response", response);
      const list = response.payload.Table;
      const userList = list.map(user => ({
        chat_id: user.chat_id,
        sender_id: user.sender_id,
        receiver_id: user.receiver_id,
        user_id: user.user_id,
        sender_name: user.sender_name,
        image_path: user.image_path,
        latest_message: user.latest_message,
        last_message_time: user.last_message_time,
        isenable_chat: user.isenable_chat,
        unread_message_count: user.unread_message_count,
        isread: user.isread
      }));
      setUsermsgsLst(userList);
    });
  }

const selectUser = async (user) => {
    const chat_id = user.chat_id || 0;
    setSelectedUser(user);
    setIsChatEnabled(user.isenable_chat !== 0);
    params.chatId = chat_id;
    paramsRead.chatId = chat_id;

    console.log("params", params);
    dispatch(getProvidermessages(params)).then((response) => {
        // console.log("getProvidermessages response", response.payload.Table);
        const list = response.payload.Table;
        if(list !== null && list !== undefined && list.length > 0){
        const providerList = list.map(provider => ({
            message_id: provider.message_id || provider.MessageId,
            chat_id: provider.chat_id || provider.ChatId,
            sender_id: provider.sender_id || provider.SenderId,
            message: provider.message || provider.Message || '',
            message_createdon: provider.message_createdon || provider.MessageCreatedOn,
            message_type_id: provider.message_type_id || provider.MessageTypeId || 1,
            file_name: provider.file_name || provider.FileName || '',
            media_path: provider.media_path || provider.MediaPath || '',
            isread: provider.isread || provider.IsRead || false,
            message_createdby: provider.message_createdby || provider.MessageCreatedBy || ''
          }));
          setProvidermsgs(providerList);
          dispatch(updateACMEReadMessage(paramsRead)).then((response) => {
            console.log("updateACMEReadMessage response", response);
            getmessagesListProvider();
          });
        }else{
          setProvidermsgs([]);
        }
    });
    setTimeout(() => scrollToBottom(true), 50);
}
  const sendNewMessage = async () => {
    if (!newMessage.trim() || !selectedUser) return;

    const formData = {
      chatId: selectedUser.chat_id || 0,
      loginUserId: currentUser.user_id,
      message: newMessage,
      receiverId: selectedUser.user_id,
      senderId: selectedUser.sender_id || userData.user_id,
      messageType: 1
    };
    
    try {
      setProvidermsgs([...providermsgs, formData]);
      dispatch(sendMessage(formData)).then((response) => {
        console.log("sendMessage response", response);
      });
   
      selectUser(selectedUser);
      setNewMessage('');
    } catch (error) {
      console.error('Error sending message:', error);
    }
  };

  const onScroll = useCallback((event) => {
    const container = messageContainer.current;
    const isNearBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - scrollThreshold;
    
    setIsUserScrolledUp(!isNearBottom);
    setShouldAutoScroll(isNearBottom);
  }, []);

  const scrollToBottom = (force) => {
    setTimeout(() => {
      if (!messageContainer.current) return;
      
      const container = messageContainer.current;
      if (force || !isUserScrolledUp) {
        container.scrollTop = container.scrollHeight;
      }
    }, 100);
  };

  const manualScrollToBottom = () => {
    setShouldAutoScroll(true);
    scrollToBottom(true);
  };
  const getUserList = async () => {
    dispatch(getPatientConversationList(params)).then((response) => {
      console.log("getmessagesListProvider response", response);
      const list = response.payload.Table;
      setUsermsgsLst(list);
    });
  }

  const openAttachmentDialog = async (messageId, chatId) => {
    const selectedMessages = providermsgs.find(msg => msg.message_id === messageId);
    if (!selectedMessages) return;

    const { chat_id, message_id, message_type_id } = selectedMessages;
    
    // Implementation would depend on your modal component
    // This is a placeholder for the modal implementation
    // You might want to use a state to control the modal visibility
  };

  const previewImage = (mediapath, messageId) => {
    const selectedImg = providermsgs.find(img => img.media_path === mediapath);
    if (!selectedImg) return;

    // Implementation would depend on your modal component
    // This is a placeholder for the modal implementation
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-3">
          <div className="card_patient_conversation">
            <div className="card-header d-flex align-items-center">
              <div className="avatar-container">
                <img src={defaultUserImage} alt="User Avatar" className="avatar-profile" />
                <span className="online-indicator"></span>
              </div>
              <input 
                type="search" 
                placeholder="Search" 
                className="form-control ml-1 w-50" 
                style={{ borderRadius: '20px' ,
                  marginRight: '1rem'
                }} 
              />
            </div>
            <hr />
            <div className="user-list">
              <div className="chat-list">
                {(!usermsgsLst || usermsgsLst.length === 0) ? (
                  <div className="no-chats-message align-items-center d-flex justify-content-center">
                    No chats available.
                  </div>
                ) : (
                  <>
                    <button className="chat-list-item" style={{ display: 'none' }}>Archive</button>
                    {usermsgsLst.map((user, index) => (
                      <button
                        key={index}
                        className={`chat-list-item ${selectedUser?.chat_id === user.chat_id ? 'chat-list__item--selected' : ''}`}
                        onClick={() => selectUser(user)}
                      >
                        <div className="chat-list-avatar">
                          {user.image_path ? (
                            <img src={user.image_path} className="chat-list-avatar-image" alt="profile" />
                          ) : (
                            <div className="chat-list-avatar-placeholder">
                              {user.sender_name ? user.sender_name.charAt(0) : '?'}
                            </div>
                          )}
                        </div>
                        <div className="chat-list-item-info">
                          <div className="chat-list-item-details">
                            <strong className="chat-list-item-name">{user.sender_name}</strong>
                            <small className="chat-list-item-time">
                              {format(new Date(user.last_message_time), 'p')}
                            </small>
                          </div>
                          <div className="chat-list-item-details">
                            <p className="chat-list-item-message">{user.latest_message}</p>
                            {user.isenable_chat === 0 && (
                              <p><i className="fa fa-bell-slash"></i></p>
                            )}
                          </div>
                          {user.isenable_chat === 1 && user.unread_message_count > 0 && (
                            <span className="unreadCount">{user.unread_message_count}</span>
                          )}
                        </div>
                      </button>
                    ))}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-9">
          {selectedUser ? (
            <div className="card_patient_conversation">
              <div className="card-header d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  {selectedUser.image_path ? (
                    <img src={selectedUser.image_path} alt="User Avatar" className="chat-avatar me-2" />
                  ) : (
                    <div className="chat-area-selected">
                      {selectedUser?.sender_name?.charAt(0) || '?'}
                    </div>
                  )}
                  <h4 className="card-title mb-0">{selectedUser?.sender_name || 'User'}</h4>
                </div>
              </div>

              <div 
                className="card-body chat-area" 
                ref={messageContainer}
                onScroll={onScroll}
              >
                {providermsgs.map((message, index) => {
                  const showDateSeparator = index === 0 || 
                    format(new Date(message.message_createdon || Date.now()), 'MM/dd/yyyy') !== 
                    format(new Date(providermsgs[index - 1]?.message_createdon || Date.now()), 'MM/dd/yyyy');

                  const messageDate = message.message_createdon ? new Date(message.message_createdon) : new Date();
                  const isValidDate = !isNaN(messageDate.getTime());

                  return (
                    <MessageContainer
                      key={message.message_id || index}
                      message={message}
                      currentUser={currentUser}
                      selectedUser={selectedUser}
                      openAttachmentDialog={openAttachmentDialog}
                      previewImage={previewImage}
                      isValidDate={isValidDate}
                      messageDate={messageDate}
                    />
                  );
                })}
              </div>

              {isUserScrolledUp && (
                <button className="scroll-to-bottom-btn" onClick={manualScrollToBottom}>
                  <i className="fa fa-arrow-down"></i>
                </button>
              )}
              

              {selectedUser?.isenable_chat === 1 && (
                <div className="card-footer chat-input me-3">
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      value={newMessage}
                      onChange={(e) => setNewMessage(e.target.value)}
                      onKeyPress={(e) => e.key === 'Enter' && sendNewMessage()}
                      disabled={!ischatEnabled}
                      placeholder="Type your message..."
                    />
                    <div className="input-group-append">
                    <button 
  className="btn btn-primary d-flex align-items-center justify-content-center"
  onClick={() => sendNewMessage()}
  disabled={!ischatEnabled}
>
  <i 
    className="fa fa-paper-plane"
    style={{ lineHeight: 1, fontSize: '16px' }}
  ></i>
</button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="text-center mt-5">
              <h4>Start conversation</h4>
              <img src={speechBubble} alt="Chat" className="icon-chat" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PatientConversation;
